import { StyleSheet, Platform } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  container: {
    marginBottom: 32,
  },

  iconContainerStyle: {
    top: 7,
    right: 8,
    position: 'absolute',
  },

  textAreaContainer: isFocused => ({
    maxHeight: 120,
    height: 120,
    borderRadius: 6,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: isFocused ? Colors.ocean : Colors.smoothGrey,
    justifyContent: 'flex-start',
    position: 'relative',
    paddingTop: 5,
    paddingBottom: Platform.OS === 'android' ? 0 : 12,
    paddingLeft: 12,
    paddingRight: 44,
  }),
  textArea: {
    justifyContent: 'flex-start',
    flex: 1,
    height: null,
    width: null,
    textAlignVertical: 'top',
    fontFamily: Fonts.type.VFFont,
    fontSize: 18,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 24,
    letterSpacing: 0,
    color: Colors.black,
  },
  vfTextStyle: {
    marginLeft: 12,
    marginTop: 10,
    fontSize: 15,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: Colors.smoothGrey,
    fontFamily: Fonts.type.VFFont,
  },
  placeholderTextNormalStyle: {
    fontFamily: Fonts.type.VFFont,
    fontSize: 20,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    backgroundColor: Colors.white,
    color: Colors.smoothGrey,
    zIndex: -1,
  },
  placeholderTextActiveStyle: isActive => ({
    height: 18,
    fontFamily: Fonts.type.VFFont,
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: 18,
    letterSpacing: 0,
    color: isActive ? Colors.ocean : Colors.smoothGrey,
    backgroundColor: Colors.white,
    paddingHorizontal: 3,
    zIndex: 1,
  }),
});
